interface StateType {
    bgBackground: string;
    btnBackground: string;
    neicengBackground: string;
    waicengBackground: string;
    zhizhenBackground: string;
    goChargeBackground: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        bgBackground: '',
        btnBackground: '',
        neicengBackground: '',
        waicengBackground: '',
        zhizhenBackground: '',
        goChargeBackground: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            state[key] = value;
        }
    },

    namespaced: true
};
